import React from "react";
import utils from "./utils";
import classes from "./index.module.css";
import RadioButton from "../../base-components/radio-button";
import Button from "../../base-components/button";
import List from "../../base-components/list";
import { setUserCurrentScreen } from "../../redux/action/app";
import { dashboard } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openBuyWait, openFundingFail } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";
import { AccountStatus, DashboardAction } from "../../utilities/Variables";

const AccountOpenSuccess = () => {
  const dispatch = useDispatch();
  const accountDetail = useSelector((state) => state.app.accountDetail);
  const targetFunds = accountDetail?.target_funds || [];
  const investmenAmount = accountDetail?.investment_amount || 100;

  const isLoading = useSelector((state) => state.app.isLoading);
  const [activeButton, setActiveButton] = React.useState("");
  const onSubmit = () => {
    dispatch(dashboard({ action: DashboardAction.Buy })).then((response) => {
      if (
        response.account_status === AccountStatus.PurchasePending ||
        response.account_status === AccountStatus.PurchasePartialSuccess
      ) {
        dispatch(setUserCurrentScreen(config.routes.buyWait));
        openBuyWait();
      } else if (response.account_status === AccountStatus.PurchaseFail) {
        dispatch(setUserCurrentScreen(config.routes.fundingFail));
        openFundingFail();
      }
    });
  };

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>
          {utils.ACCOUNT_OPEN_SUCCESS_HEADER_1}
          <br />
          {utils.ACCOUNT_OPEN_SUCCESS_HEADER_2}
        </h2>
        <p className={classes.SubHeading}>
          {utils.ACCOUNT_OPEN_SUCCESS_SUBHEADING_1}
          <br />
          {utils.ACCOUNT_OPEN_SUCCESS_SUBHEADING_2}
        </p>
      </div>
      <div className={classes.middle}>
        {targetFunds.map((item) => {
          return (
            <div className={classes.stock}>
              <p className={classes.stockBold}>
                {item.symbol}
              </p>
              <p className={classes.stockBold}>
                {item.percentage + "% of portfolio"}
              </p>
              <p className={classes.stockDescription}>{item.description}</p>
            </div>
          );
        })}
        <p className={classes.SubHeading}>
          {utils.ACCOUNT_OPEN_SUCCESS_CONTENT_1(investmenAmount)}
        </p>
        <p className={classes.SubHeading}>
          {utils.ACCOUNT_OPEN_SUCCESS_CONTENT_2}
        </p>
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
        >
          {utils.ACCOUNT_OPEN_SUCCESS_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default AccountOpenSuccess;
